import { render } from "./ContentFooter.vue?vue&type=template&id=e48d407e"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
script.render = render

export default script